module.exports = __webpack_public_path__ + "static/calcots-e22b1e0d0774b6b2ef92832e10ac4013.jpg";